export default "__VITE_ASSET__ChBz67tc__"